import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function EmailToStaff() {
  const [userId, setUserId] = useState("");
  const [cityIds, setCityIds] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [isDropdownLocationOpen, setIsDropdownLocationOpen] = useState(false);
  const dropdownLocationRef = useRef(null);
  const [staffIds, setStaffIds] = useState([]);
  const navigate = useNavigate();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [staffs, setStaffs] = useState([]);



  const [roles, setRoles] = useState([
    {
      _id: 1,
      name: "sales"
    },
    {
      _id: 2,
      name: "survey"
    },
    {
      _id: 3,
      name: "telecalling"
    },
    {
      _id: 4,
      name: "data entry"
    },
    {
      _id: 5,
      name: "branch manager"
    },
    {
      _id: 6,
      name: "freelancer"
    }
  ]);

  const initialFormData = {
    city: "",
    role: "",
    recipients: [],
    title: "",
    description: "",
  }
  const [formData, setFormData] = useState(initialFormData)

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          // setSelectedCity(userCity)
          setFormData({ ...formData, city: userCity })
          fetchStaffs(userCity)
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  // Fetch staffs
  const fetchStaffs = async () => {
    try {
      const res = await HomeService.getStaffs();
      console.log("UYT99", res.data);

      if (res?.data) {
        formData?.city && formData?.role && setStaffs(res.data.filter((item) => item?.city._id === formData?.city && item.role === formData?.role))
        formData?.city && !formData?.role && setStaffs(res.data.filter((item) => item?.city._id === formData?.city));
      }
    } catch (error) {
      console.error("Error fetching staffs:", error);
    }
  }



  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const usersResponse = await HomeService.getUsers();
  //       const citiesResponse = await HomeService.getCities();



  //       if (userCity) {
  //         setUserList(usersResponse.data.filter(item => item?.city._id === userCity))
  //       } else {
  //         setUserList(usersResponse?.data || []);
  //       }
  //       setCityList(citiesResponse?.data || []);
  //     } catch (error) {
  //       toast.error("Failed to fetch user or city list.");
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   fetchData();

  //   // Close dropdown if clicked outside
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsDropdownOpen(false);
  //     }
  //   };

  //   // Close dropdown if clicked outside
  //   const handleClickLocationOutside = (event) => {
  //     if (dropdownLocationRef.current && !dropdownLocationRef.current.contains(event.target)) {
  //       setIsDropdownLocationOpen(false);
  //     }
  //   };



  //   document.addEventListener("mousedown", handleClickOutside);
  //   document.addEventListener("mousedown", handleClickLocationOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //     document.removeEventListener("mousedown", handleClickLocationOutside);
  //   };


  // }, []);

  useEffect(() => {
    fetchCities();
  }, [])

  useEffect(() => {
    fetchStaffs()
  }, [formData.city, formData.role])

  const handleAttachmentUpload = async (e) => {
    const data = new FormData();
    data.append("attachment", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("file-upload", "POST", data);
      console.log("POO164", res);

      if (res?.status) {
        setFormData({ ...formData, attachment: res?.doc })
        toast.success("Attachment uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload attachment.");
      console.error("Error uploading attachment:", error);
    }
  }

  const [buttonText, setButtonText] = useState("Send email")

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.city) { return toast.error("Select City") }
    if (!formData.role) { return toast.error("Select Role") }
    if (formData.recipients.length === 0) { return toast.error("Choose Staff") }
    console.log("UYT180", formData);
    setButtonText("Sending emails. Please wait...")
    // return
    try {
      const res = await HomeService.sendMailToStaff(formData);
      if (res?.success) {
        toast.success(res?.message);
        setFormData(initialFormData)
        setButtonText("Send another email")
        navigate("/sent-email-to-staff");
      }
    } catch (error) {
      toast.error("Failed to send email.");
      console.error("Error sending email:", error);
    }
  };




  const handleStaffChange = (e) => {
    const value = e.target.value;
    setStaffIds(
      (prev) =>
        prev.includes(value)
          ? prev.filter((_id) => _id !== value) // Remove if already selected
          : [...prev, value] // Add if not selected
    );
    setAllSelected(false)
  };

  useEffect(() => {
    setFormData({ ...formData, recipients: staffIds })
  }, [staffIds])

  const [allSelected, setAllSelected] = useState(false)
  const handleAllStaffs = (e) => {
    console.log("JUY189", staffs, staffIds, e.target.value);
    let allStaffs = staffs.map(item => item._id);
    if (allSelected) {
      allStaffs = []
    }
    setStaffIds(allStaffs)
    setAllSelected(!allSelected)

  };



  const toggleDropdownLocation = () => {
    setIsDropdownLocationOpen(!isDropdownLocationOpen); // Toggle dropdown visibility
  };



  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Email To Staff
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  <select
                    id="user"
                    className="form-control"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    required
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName}-<h6>{user.email}</h6>
                      </option>
                    ))}
                  </select>
                </div> */}

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Price<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="form-control"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                  />
                </div> */}

                <div className="col-md-4 mt-3">
                  <label htmlFor="cities">
                    City<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={formData.city}
                    onChange={(e) => {
                      // setSelectedCity(e.target.value)
                      setFormData({ ...formData, city: e.target.value })
                      setAllSelected(false)
                      setStaffIds([])
                    }}
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Role<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="role"
                    value={formData?.role || ""}
                    onChange={(e) => {
                      setFormData({ ...formData, role: e.target.value })
                    }}
                  >
                    <option value="" disabled>---Select---</option>
                    {roles.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mt-3">
                  <label>
                    Staff<span className="text-danger">*</span>
                  </label>
                  {/* <select
                    className="form-control"
                    value={selectedLocality}
                    onChange={(e) => setSelectedLocality(e.target.value)}
                  >
                    <option value="" disabled>---Select---</option>
                    {staffs.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select> */}

                  <div className="dropdown" ref={dropdownLocationRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={toggleDropdownLocation}
                    >
                      {staffIds.length === 0
                        ? staffs.length > 0 ? "Select Staff(s)" : "No staffs found"
                        : `${staffIds.length} staff selected`}
                    </button>
                    {isDropdownLocationOpen && staffs.length > 0 && (
                      <div className="dropdown-menu-for-city">
                        {
                          staffs.length > 0 &&
                          <div className="form-check"
                            style={{
                              borderBottom: "solid 1px #eee"
                            }}
                          >
                            <input
                              type="checkbox"
                              id="s_all" // Properly linking with label
                              value="all"
                              checked={allSelected}
                              onChange={handleAllStaffs}
                              className="form-check-input"
                            />
                            <label
                              className="form-check-label"
                            >
                              Select all
                            </label>
                          </div>
                        }

                        {staffs.map((item) => (
                          <div key={item._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${item._id}`}
                              value={item._id}
                              checked={staffIds.includes(item._id)}
                              onChange={handleStaffChange}
                              className="form-check-input"
                            />
                            <label
                              className="form-check-label"
                            >
                              {item.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {/* </div> */}

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    Apartment<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={selectedCity}
                    onChange={(e) => {
                      setSelectedCity(e.target.value)
                      setAllSelected(false)
                      setStaffIds([])
                    }}
                  >
                    <option value="" disabled>---Select---</option>
                    {apartments.map((item, key) => (
                      <option key={key} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>


                </div> */}

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div> */}

                <div className="col-md-12 mt-3">
                  <label>
                    Subject
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData?.title}
                    onChange={(e) => {
                      setFormData({ ...formData, title: e.target.value })
                    }}
                    placeholder="Enter mail subject"
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="endDate">
                    Content/Message
                  </label>
                  <textarea
                    className="form-control"
                    value={formData.description}
                    onChange={(e) => {
                      setFormData({ ...formData, description: e.target.value })
                    }}
                    placeholder="Enter message"
                  ></textarea>
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="cityImage">
                    Attachment
                  </label>
                  {/* {formData.attachment && (
                    <img
                      src={formData.attachment}
                      alt={formData.attachment.split(".").pop()}
                      width="100"
                      style={{ display: "block", marginTop: "10px" }}
                    />
                  )} */}
                  <input
                    type="file"
                    name="attachment"
                    className="form-control"
                    onChange={handleAttachmentUpload}
                    accept="*"
                  />
                </div>


              </div>


              <button type="submit" style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} className="btn mt-3">
                {buttonText}
              </button>

            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default EmailToStaff;
